"use client"
import { useModal } from '@/components/hooks'

import {
  PageComponentResidents,
  CommunityListResult,
} from '@/components/devlink'

type CommunitySelectRuntimeProp = {
  options: {
    v: string
    t: string
  }[]
}

type Props = {
  communitySelectRuntimeProp: CommunitySelectRuntimeProp
}

export default function Residents(props: Props) {
  const { toggle: onClick } = useModal('.hide-opac-0---community-list-popover-modal-copy', 'appear', false)
  const mergeProps = {
    toggleModalRuntimeProps: { onClick },
  }

  return (
    <PageComponentResidents {...mergeProps}>
    {props.communitySelectRuntimeProp.options.reduce((acc: any[], option) => {
      if (!option.v) return acc
      return [
        ...acc,
        <CommunityListResult
          key={option.v}
          text={option.t}
          runtimeProps={{
            options: {
              href: option.v,
              target: '_blank',
            },
            onClick,
          }}
        />
      ]
    }, [])}
    </PageComponentResidents>
  )
}
